const routes = {
  '/app/use-case': {
    fetch: () =>
      import(
        /* webpackChunkName: 'use-case-route' */ 'app/use-case/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
